import { useState } from "react";
import { useLanguage } from "../context/LanguageContext";

const STORAGE_KEY = "ecobambu_cookie_consent";

export default function CookieBanner() {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(() => !localStorage.getItem(STORAGE_KEY));

  if (!visible) return null;

  const choose = (value) => {
    localStorage.setItem(STORAGE_KEY, value);
    setVisible(false);
  };

  return (
    <aside className="cookie-banner" aria-label="Cookie preferences">
      <p>{t("cookieMessage")}</p>
      <div>
        <button className="button-secondary" onClick={() => choose("necessary")}>{t("essentialOnly")}</button>
        <button className="button-primary" onClick={() => choose("all")}>{t("acceptAll")}</button>
      </div>
    </aside>
  );
}
